// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"e9018eea","498":"312b701b"}[chunkId] + ".css";
};